import { IPromise, IScope } from 'angular'
import { vn } from 'vend-number'

import { EVENT } from '../../../constants'
import { $rootScope, $q } from '../../../ng-compat/imports'
import { RoundedNumber } from './CashPaymentModal'

interface CashModalOptions {
  currencySymbol: string
  roundedAmountTendered: RoundedNumber
  roundedBalance: RoundedNumber
  rounding: string
}

/**
 * Controller class for the quick cash modal
 *
 * @class CashModalController
 */
export class CashModalController {
  public readonly close: () => void
  public readonly currencySymbol: string
  public readonly roundedAmountTendered: RoundedNumber
  public readonly roundedBalance: RoundedNumber
  public readonly rounding: string
  public readonly isPartialPayment: boolean
  public readonly openCashDrawer: () => void
  private readonly internalClose: (val: IPromise<any>) => void

  constructor(
    $scope: IScope,
    close: (val: IPromise<any>) => void,
    public readonly options: CashModalOptions,
    private readonly vdEscapeStack: any
  ) {
    'ngInject'
    this.internalClose = close
    this.close = () => this.internalClose($q.reject())

    this.currencySymbol = options.currencySymbol
    this.roundedAmountTendered = options.roundedAmountTendered
    this.roundedBalance = options.roundedBalance
    this.rounding = options.rounding
    this.isPartialPayment = vn(this.roundedAmountTendered.rounded)
      .abs()
      .lt(vn(this.roundedBalance.rounded).abs())
    this.openCashDrawer = () => {
      $rootScope.$emit(EVENT.PRINT, { type: 'open-drawer' })
    }
    // Handle escape key
    this.vdEscapeStack.register(this.close)
    $scope.$on('$destroy', () => this.vdEscapeStack.deregister(this.close))
  }
}
